import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import favicon from '../images/Logo.png';
import AcercaDe from '../elements/About';
import Footer from '../elements/Footer';
import Caja from '../styles/components/box.styles';

const About = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (  
        <>
            <Helmet>
                <link rel="shortcut icon" href={ favicon } type="image/x-icon" data-react-helmet="true"/>
            </Helmet>
            <Caja>
                <AcercaDe className="about"/>
                <Footer/>
            </Caja>
        </>
    );
}
 
export default About;